import * as Yup from 'yup'
import {BaseEntity} from '../../../../shared/models/ApiModels'

export const ADMIN_CORPORATE_PATH = '/admin/corporate'

/** CorporateResponse */
export interface ICorporateModel extends BaseEntity {
  name: string
  slug?: string | null
  taxNumber?: string | null
  taxOffice?: string | null
  email?: string | null
  phone?: string | null
  address?: string | null
  active: boolean
  tagline?: string | null
  about?: string | null
  industry?: string | null
  employeeCount?: string | null
  country?: string | null
  website?: string | null
  linkedinUrl?: string | null
  termsUrl?: string | null
  privacyUrl?: string | null
  logoDocumentId?: string | null
  headerDocumentId?: string | null
  createdDate?: string
}

/** Admin oluşturma / güncelleme gövdesi (CorporateRequest) */
export interface ICorporateRequest {
  name: string
  slug: string
  taxNumber: string
  taxOffice: string
  email: string
  phone: string
  address: string
}

/** CorporateUserResponse */
export interface ICorporateUserModel {
  userId: string
  username: string
  email: string
  firstName?: string | null
  lastName?: string | null
  defaultCorporate: boolean
  active: boolean
}

const TURKISH_CHARS: Record<string, string> = {ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u'}

/** Firma adından kariyer sayfası adresi üretir: "Eywa Teknoloji A.Ş." → "eywa-teknoloji-a-s" */
export const slugify = (value: string) =>
  value
    .toLocaleLowerCase('tr-TR')
    .replace(/[çğıöşü]/g, (char) => TURKISH_CHARS[char])
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)

export const validationCorporate = Yup.object().shape({
  name: Yup.string().trim().required('Firma adı zorunludur').max(150, 'En fazla 150 karakter'),
  slug: Yup.string()
    .required('Sayfa adresi zorunludur')
    .min(2, 'En az 2 karakter')
    .max(60, 'En fazla 60 karakter')
    .matches(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'Küçük harf, rakam ve tire kullanınız'),
  taxNumber: Yup.string().trim().max(20, 'En fazla 20 karakter'),
  taxOffice: Yup.string().trim().max(100, 'En fazla 100 karakter'),
  email: Yup.string().trim().email('Geçerli bir e-posta adresi giriniz').max(150),
  phone: Yup.string().trim().max(20, 'En fazla 20 karakter'),
  address: Yup.string().trim().max(500, 'En fazla 500 karakter'),
})

export const initialCorporateForm: ICorporateRequest = {
  name: '',
  slug: '',
  taxNumber: '',
  taxOffice: '',
  email: '',
  phone: '',
  address: '',
}

export const toCorporateForm = (corporate: ICorporateModel): ICorporateRequest => ({
  name: corporate.name,
  slug: corporate.slug ?? '',
  taxNumber: corporate.taxNumber ?? '',
  taxOffice: corporate.taxOffice ?? '',
  email: corporate.email ?? '',
  phone: corporate.phone ?? '',
  address: corporate.address ?? '',
})
